import { Component, Input } from '@angular/core';

export interface LoadingOverlayConfig {
  title?: string;
  subtitle?: string;
  message?: string;
  icon?: string;
  buttonText?: string;
  buttonColor?: 'primary' | 'accent' | 'warn';
  spinnerColor?: 'primary' | 'accent' | 'warn';
  backgroundColor?: 'primary' | 'accent' | 'warn' | 'custom';
  customBackgroundColor?: string;
  showButton?: boolean;
  onButtonClick?: () => void;
}

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
})
export class LoadingOverlayComponent {
  @Input() show: boolean = false;
  @Input() config: LoadingOverlayConfig = {};

  get backgroundColorClass(): string {
    if (this.config.backgroundColor === 'custom' && this.config.customBackgroundColor) {
      return '';
    }
    return this.config.backgroundColor ? `bg-${this.config.backgroundColor}-900` : 'bg-accent-900';
  }

  get backgroundColorStyle(): string {
    if (this.config.backgroundColor === 'custom' && this.config.customBackgroundColor) {
      return this.config.customBackgroundColor;
    }
    return '';
  }

  get borderColorClass(): string {
    return this.config.backgroundColor
      ? `border-${this.config.backgroundColor}-700`
      : 'border-accent-700';
  }

  get titleColorClass(): string {
    return 'text-white';
  }

  get subtitleColorClass(): string {
    return this.config.backgroundColor
      ? `text-${this.config.backgroundColor}-200`
      : 'text-accent-200';
  }

  get messageColorClass(): string {
    return this.config.backgroundColor
      ? `text-${this.config.backgroundColor}-300`
      : 'text-accent-300';
  }

  get buttonColorClass(): string {
    const color = this.config.buttonColor || 'primary';
    return `text-${color}-300 hover:text-${color}-100`;
  }

  onButtonClick(): void {
    if (this.config.onButtonClick) {
      this.config.onButtonClick();
    }
  }
}
